import { PlannerValidation } from '@inter-ikea-storageone/range';
import { ComponentIds } from '@inter-ikea-core/core';
export class DrawerPlacementValidation extends PlannerValidation {
    constructor(coreApi) {
        super(coreApi, 'DrawerPlacementValidation');
    }
    validateCurrentState() {
        return this.validationOK();
    }
    validateSnap(snapActionCandidate) {
        const entity = snapActionCandidate.guestRoot;
        if (!snapActionCandidate.hostConnector)
            return this.validationOK();
        return this.validate(entity, snapActionCandidate);
    }
    getHeight(entity) {
        return entity.getComponent(ComponentIds.COMMUNICATION_SIZE_COMPONENT_ID)?.size.height;
    }
    validateDrawerConnectionOnFrame(drawerHeight, snapActionCandidate) {
        // Connectors are as follows: left-series-1, right-series-1, left-series-2, right-series-2 etc. and for tv-benches it's the same but split into zones.
        // We only care about the final number on the hostconnector as that is the hole number that is used for the drawer placement.
        const connectorKey = snapActionCandidate.hostConnector.key.split('-').pop();
        if (!connectorKey)
            return false;
        const parsedConnectorKeyAsInt = parseInt(connectorKey, 10);
        const frameHeight = this.getHeight(snapActionCandidate.host);
        // For 38 height frames we don't accept placements above hole number 8
        if (frameHeight === 380 && drawerHeight === 380) {
            if (parsedConnectorKeyAsInt > 0) {
                return false;
            }
            // For 64 height frames we don't accept placements above hole number 8
        }
        else if (frameHeight === 640 && drawerHeight === 380) {
            if (parsedConnectorKeyAsInt > 8) {
                return false;
            }
            // For 128 height frames we don't accept placements below hole number 28
        }
        else if (frameHeight === 1280 && drawerHeight === 380) {
            if (parsedConnectorKeyAsInt > 28) {
                return false;
            }
            // For 192 height frames we don't accept placements above hole number 48
        }
        else if (frameHeight === 1920 && drawerHeight === 380) {
            if (parsedConnectorKeyAsInt > 48) {
                return false;
            }
        }
        return true;
    }
    validate(entity, snapActionCandidate) {
        if (!entity.hasComponent(ComponentIds.DRAWER_COMPONENT_ID)) {
            return this.validationOK();
        }
        const drawerHeight = this.getHeight(entity);
        // Only apply validation if the drawer has a height of 38
        if (drawerHeight !== 380) {
            return this.validationOK();
        }
        if (!this.validateDrawerConnectionOnFrame(drawerHeight, snapActionCandidate)) {
            return this.validationFail(`Cannot place a drawer on that hole number`);
        }
        return this.validationOK();
    }
}
//# sourceMappingURL=DrawerPlacementValidation.js.map